/**
 * Fits the PDP media column to the first screen.
 *
 * The gallery starts part-way down the page -- below the announcement bar, the
 * header and the section's own padding -- so "one screen" is the viewport minus
 * that offset minus the gap the merchant asked for. None of those are known to
 * CSS, so the height is measured here and published as --pdp-gallery-height for
 * the stylesheet to consume. Nothing about scrolling changes: the column scrolls
 * away with the rest of the page exactly as it did before.
 *
 * The offset is taken from the document, not the viewport, so a reload part-way
 * down the page measures the same as a reload at the top.
 */
(function () {
  const SELECTOR = '.product--onefold-gallery .product__media-wrapper > media-gallery';
  const FALLBACK_GAP = 20;
  const MIN_HEIGHT = 320;

  function apply() {
    document.querySelectorAll(SELECTOR).forEach((gallery) => {
      const styles = getComputedStyle(gallery);
      const gap = parseFloat(styles.getPropertyValue('--pdp-gallery-gap')) || FALLBACK_GAP;
      const offset = gallery.getBoundingClientRect().top + window.scrollY;
      const height = Math.round(window.innerHeight - offset - gap);

      gallery.style.setProperty('--pdp-gallery-height', `${Math.max(height, MIN_HEIGHT)}px`);
    });
  }

  function schedule() {
    clearTimeout(schedule.timer);
    schedule.timer = setTimeout(apply, 150);
  }

  function init() {
    apply();
    window.addEventListener('resize', schedule);
    // Webfonts and the announcement bar settle after first paint and move the
    // gallery down, which changes the offset the height is derived from.
    window.addEventListener('load', apply);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
